export default __webpack_public_path__ + "static/media/bgbarb.1527ab58.jpg";